import { createReducer, on } from '@ngrx/store';
import { DailyJournalActions } from './journal.actions';
import { dailyJournalState, intialDailyJournalState } from './journal.state';

export const dailyJournalReducer = createReducer(
  dailyJournalState,
  on(DailyJournalActions.reset, () => intialDailyJournalState()),
  on(DailyJournalActions.setLoading, (state, { key, value }) => ({
    ...state,
    loading: { ...state.loading, [key]: value }
  })),
  on(
    DailyJournalActions.setDailyJournalTypes,
    (state, { dailyJournalTypes }) => ({
      ...state,
      dailyJournalTypes
    })
  ),
  on(
    DailyJournalActions.setDailyJournalQuestions,
    (state, { dailyJournalQuestions }) => ({
      ...state,
      dailyJournalQuestions
    })
  ),
  on(
    DailyJournalActions.setDailyJournalFollowUpQuestions,
    (state, { dailyJournalFollowUpQuestions }) => ({
      ...state,
      dailyJournalFollowUpQuestions
    })
  ),
  on(
    DailyJournalActions.setDailyJournalSettings,
    (state, { dailyJournalSettings }) => ({
      ...state,
      dailyJournalSettings
    })
  ),
  on(DailyJournalActions.saveDailyJournalSuccess, (state, { key, value }) => ({
    ...state,
    submitStatus: { ...state.submitStatus, [key]: value }
  })),
  on(
    DailyJournalActions.setDailyJournalSummary,
    (state, { dailyJournalSummary }) => ({
      ...state,
      dailyJournalSummary
    })
  ),
  on(
    DailyJournalActions.setDailyJournalSummaryMonths,
    (state, { dailyJournalSummaryMonths }) => ({
      ...state,
      dailyJournalSummaryMonths: {
        ...state.dailyJournalSummaryMonths,
        ...dailyJournalSummaryMonths
      }
    })
  ),
  on(
    DailyJournalActions.setDailyJournalSummaryParams,
    (state, { summaryParams }) => ({
      ...state,
      params: { ...state.params, summaryParams }
    })
  ),
  on(
    DailyJournalActions.setDailyJournalAnswer,
    (state, { dailyJournalAnswer }) => ({
      ...state,
      dailyJournalAnswer
    })
  ),
  on(DailyJournalActions.setError, (state, { key, value }) => ({
    ...state,
    errors: { ...state.errors, [key]: value }
  }))
);
